import { t } from 'i18next'
import * as z from 'zod'

import { PASSWORD_MAX_LENGTH, PASSWORD_MIN_LENGTH } from '@/const/app'

import { PasswordChangeFormVO } from './type'

export const schema = z
  .object({
    currentPassword: z
      .string()
      .nonempty(t('auth.validation.required'))
      .min(
        PASSWORD_MIN_LENGTH,
        t('auth.validation.minLength', { length: PASSWORD_MIN_LENGTH })
      )
      .max(
        PASSWORD_MAX_LENGTH,
        t('auth.validation.maxLength', { length: PASSWORD_MAX_LENGTH })
      ),
    newPassword: z
      .string()
      .nonempty(t('auth.validation.required'))
      .min(
        PASSWORD_MIN_LENGTH,
        t('auth.validation.minLength', { length: PASSWORD_MIN_LENGTH })
      )
      .max(
        PASSWORD_MAX_LENGTH,
        t('auth.validation.maxLength', { length: PASSWORD_MAX_LENGTH })
      ),
    newPasswordConfirm: z.string().nonempty(t('auth.validation.required')),
  })
  .refine((data) => data.newPassword === data.newPasswordConfirm, {
    message: t('auth.validation.passwordMismatch'),
    path: ['newPasswordConfirm'],
  })

export const formLabels: Record<keyof PasswordChangeFormVO, string> = {
  currentPassword: t('auth.password.currentPassword'),
  newPassword: t('auth.password.newPassword'),
  newPasswordConfirm: t('auth.password.newPasswordConfirm'),
}

export const defaultValues: PasswordChangeFormVO = {
  currentPassword: '',
  newPassword: '',
  newPasswordConfirm: '',
}
